export const RESET = 'USERDATAFIRM_LIST_RESET'
export const SET_ITEMS = 'USERDATAFIRM_LIST_SET_ITEMS'
export const SET_ERROR = 'USERDATAFIRM_LIST_SET_ERROR'
export const SET_VIEW = 'USERDATAFIRM_LIST_SET_VIEW'
export const TOGGLE_LOADING = 'USERDATAFIRM_LIST_TOGGLE_LOADING'
